import axios from "axios";
import "devexpress-richedit/dist/dx.richedit.css";
import { LoadPanel, TextBox } from "devextreme-react";
import { Popup } from "devextreme-react/popup";
import "devextreme/dist/css/dx.light.css";
import { useEffect, useRef, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { ColumnDropdown } from "../../../components/Dropdownn";
import { DynamicTabb } from "../../../components/DynamicTab/DynamicTab";
import { logOut } from "../../../components/Logout";
import { Toster } from "../../../components/Toster/Toster";
import { handleGetLocal } from "../../../services/auth-service";
import { ReportCatalogFindPopup } from "./ReportCatalogFindPopup";
import RichEditComponent from "./RichEditComponent";

const DropDown = ({ dropDownData, setfields, fields, fieldNmae, reset, disabled }) => {
  return (
    <>
      <ColumnDropdown
        data={dropDownData}
        setfields={setfields}
        fields={fields}
        fieldNmae={fieldNmae}
        value={fields[fieldNmae]?.name}
        reset={reset}
        disabled={disabled}
      />
    </>
  );
};

const ReportCatalog = () => {
  const [loading, setLoading] = useState(false);
  const pathname = handleGetLocal("pathURL");
  const navigate = useNavigate();
  const [toastConfig, setToastConfig] = useState({
    isVisible: false,
    type: "",
    message: "",
  });
  const [isFindPopupVisible, setIsFindPopupVisible] = useState(false);
  const [masterDropdownValues, setMasterDropdownValues] = useState([]);
  const [add, setAdd] = useState(false);
  const [clone, setClone] = useState(false);
  const [rowData, setRowData] = useState("");
  const [editToggle, setEditToggle] = useState(false);
  const [htmlData, setHtmlData] = useState();
  const [documentAsBase64, setdocumentAsBase64] = useState();
  const [isDocLoaded, setIsDocLoaded] = useState(false);
  const fileInputRef = useRef(null);
  const [originalData, setOriginalData] = useState(null);
  const [editorReloadKey, setEditorReloadKey] = useState(0);

  const handleCancel = () => {
    if (!originalData) return;

    setFields(originalData.fields);
    setdocumentAsBase64(originalData.documentAsBase64);
    setHtmlData(originalData.htmlData);
    setRowData(originalData.rowData);

    setAdd(false);
    setClone(false);
    setEditToggle(false);
    setEditorReloadKey((prev) => prev + 1);
  };

  useEffect(() => {
    setIsDocLoaded(!!documentAsBase64 && documentAsBase64 !== "");
  }, [documentAsBase64]);

  const isEditable = add || editToggle;
  const isInitial = !rowData || Object.keys(rowData).length === 0;

  const disableEdit = editToggle || isInitial;
  const disableCopy = isInitial || !isDocLoaded;

  const getReportsRef = useRef(null);

  const updatedocumentAsBase64 = (value) => {
    setdocumentAsBase64(value);
  };

  const initialState = {
    reportname: { name: "", id: "" },
    reporttype: { name: "", id: "" },
    parentform: { name: "", id: "" },
    sreporthtml: "",
    sreportrtf: "",
  };
  const [fields, setFields] = useState(initialState);

  const resetFields = () => {
    setFields(initialState);
  };
  const rtfbase64 =
    "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";

  const postbody = {
    GReportCatalogId: fields?.reportname?.id ? fields?.reportname?.id : "00000000-0000-0000-0000-000000000000",
    SName: fields?.reportname?.name,
    GReportTypeId: fields?.reporttype?.id,
    SReportRtf: documentAsBase64,
    BTemplate: 0,
    GParentId: fields?.parentform?.id,
  };
  const getMasterDropdownValues = async () => {
    await axios
      .get(`${process.env.REACT_APP_API_URL}/api/report-catalog/dropdown`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: `${pathname}`,
        },
      })
      .then((val) => {
        setMasterDropdownValues(val?.data?.data);
      })
      .catch((val) => {
        if (!val?.response) {
          Navigate(`/error/500`);
        } else if (val?.response?.status === 401) {
          logOut();
        }
      });
  };

  const SaveData = async () => {
    if (!fields?.reporttype?.id) {
      setToastConfig({
        isVisible: true,
        message: "Please Select report type",
        type: "error",
      });

      setTimeout(() => {
        setToastConfig((prev) => ({
          ...prev,
          isVisible: false,
        }));
      }, 2000);

      return;
    }
    await axios
      .post(`${process.env.REACT_APP_API_URL}/api/report-catalog/add-edit-reports`, postbody, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: `${pathname}`,
        },
      })
      .then((val) => {
        setToastConfig({
          ...toastConfig,
          isVisible: true,
          message: "Successfully Added/Edited",
          type: "success",
        });
        setTimeout(() => {
          setToastConfig({
            ...toastConfig,
            isVisible: false,
            message: "Successfully Added/Edited",
            type: "success",
          });
        }, 1900);
        setEditToggle(false);
        setFields((prev) => ({
          ...prev,
          reportname: {
            name: val?.data?.data?.sName,
            id: val?.data?.data?.gReportCatalogId,
          },
        }));
        if (getReportsRef.current) {
          getReportsRef.current("");
        }
      })
      .catch((val) => {
        if (!val?.response) {
          Navigate(`/error/500`);
        } else if (val?.response?.status === 401) {
          logOut();
        }
      });
  };

  const getParentFormName = (gParentId) => {
    const matchingItem = masterDropdownValues?.reportName?.find(
      (item) => item?.key?.toUpperCase() === gParentId?.toUpperCase(),
    );
    // Return the name if a match is found, otherwise return sReportTypeName
    return matchingItem ? matchingItem.value : "";
  };

  const printTableData = () => {
    var printWindow = window.open("", "", "width=600,height=600");
    printWindow.document.open();

    printWindow.document.write(`
          <html>
          <head>
            <title>Report Catalog</title>
            <style>
              /* Add your CSS styles here */
            </style>
          </head>
          <body>
            <div>${htmlData}</div>
          </body>
          </html>
        `);

    printWindow.document.close();
    printWindow.print();
    printWindow.close();
  };

  const PrintDocument = () => {
    const printDiv = document.querySelector('div[title="Print"][aria-label="Print"]');
    if (printDiv) {
      // Trigger the click event
      printDiv.click();
    } else {
      console.error("Print div not found");
    }
  };

  const defaultBase64 =
    "e1xydGYxXGRlZmYwe1xmb250dGJse1xmMCBDYWxpYnJpO317XGYxIFRpbWVzIE5ldyBSb21hbjt9e1xmMiBBcmlhbDt9fXtcY29sb3J0YmwgO1xyZWQwXGdyZWVuMFxibHVlMjU1IDt9e1wqXGRlZmNocCBcZjFcZnMyMn17XHN0eWxlc2hlZXQge1xxbFxmMVxmczIyIE5vcm1hbDt9e1wqXGNzMVxmMVxmczIyIERlZmF1bHQgUGFyYWdyYXBoIEZvbnQ7fXtcKlxjczJcdWxcZjFcZnMyMlxjZjEgSHlwZXJsaW5rO317XCpcY3MzXHNiYXNlZG9uMVxmMVxmczIyIExpbmUgTnVtYmVyO317XCpcdHM0XHRzcm93ZFxmczIyXHFsXHRzdmVydGFsdFxjbHR4bHJ0YiBOb3JtYWwgVGFibGU7fXtcKlx0czVcdHNyb3dkXGYyXGZzMjJccWxcdHJicmRydFxicmRyc1xicmRydzEwXHRyYnJkcmxcYnJkcnNcYnJkcncxMFx0cmJyZHJiXGJyZHJzXGJyZHJ3MTBcdHJicmRyclxicmRyc1xicmRydzEwXHRyYnJkcmhcYnJkcnNcYnJkcncxMFx0cmJyZHJ2XGJyZHJzXGJyZHJ3MTBcdHJwYWRkZmwzXHRycGFkZGwxMDhcdHJwYWRkZnIzXHRycGFkZHIxMDhcdHN2ZXJ0YWx0XGNsdHhscnRiIFRhYmxlIFNpbXBsZSAxO317XCpcdHM2XHRzcm93ZFxmMlxmczIyXHFsXHRyYnJkcnRcYnJkcnNcYnJkcncxMFx0cmJyZHJsXGJyZHJzXGJyZHJ3MTBcdHJicmRyYlxicmRyc1xicmRydzEwXHRyYnJkcnJcYnJkcnNcYnJkcncxMFx0cmJyZHJoXGJyZHJzXGJyZHJ3MTBcdHJicmRydlxicmRyc1xicmRydzEwXHRibGluZHR5cGUzXHRibGluZDBcdHN2ZXJ0YWx0XGNsdHhscnRiIDEwODEwODMzVGFibGUgR3JpZDt9e1wqXHRzN1x0c3Jvd2RcZjJcZnMyMlxxbFx0cmJyZHJ0XGJyZHJzXGJyZHJ3MTBcdHJicmRybFxicmRyc1xicmRydzEwXHRyYnJkcmJcYnJkcnNcYnJkcncxMFx0cmJyZHJyXGJyZHJzXGJyZHJ3MTBcdHJicmRyaFxicmRyc1xicmRydzEwXHRyYnJkcnZcYnJkcnNcYnJkcncxMFx0c3ZlcnRhbHRcY2x0eGxydGIgMTA4MTA4MzNUYWJsZSBTaW1wbGUgMTt9fXtcKlxsaXN0b3ZlcnJpZGV0YWJsZX17XGluZm99XG5vdWljb21wYXRcc3BseXR3bmluZVxodG1hdXRzcFxleHBzaHJ0blxzcGx0cGdwYXJcZGVmdGFiNzIwXHNlY3RkXG1hcmdsc3huNzIwXG1hcmdyc3huNzIwXG1hcmd0c3huNzIwXG1hcmdic3huNzIwXGhlYWRlcnk3MjBcZm9vdGVyeTcyMFxwZ3dzeG4xMjI0MFxwZ2hzeG4xNTg0MFxjb2xzMVxjb2xzeDcyMHtcaGVhZGVyclxwYXJkXHBsYWluXHFse1xmMVxmczIyXGNmMCAgIH1cZjFcZnMyMlxjZjBccGFyfVxwYXJkXHBsYWluXHFsXGYxXGZzMjJcY2YwXHBhcn0=";
  useEffect(() => {
    getMasterDropdownValues();
  }, []);

  useEffect(() => {
    setFields((prev) => ({
      ...prev,
      reportname: {
        name: rowData?.sName,
        id: rowData?.gReportCatalogId,
      },
      reporttype: {
        name: rowData?.sReportTypeName,
        id: rowData?.gReportTypeId,
      },
      parentform: {
        name: getParentFormName(rowData?.gParentId),
        id: rowData?.gParentId ? rowData?.gParentId : "00000000-0000-0000-0000-000000000000",
      },
    }));
    setHtmlData(rowData.sReportHtml);
    setdocumentAsBase64(rowData?.sReportRtf);
    setEditorReloadKey((prev) => prev + 1);
  }, [rowData]);

  const handleFileImport = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const fileName = file.name.toLowerCase();
    if (!fileName.endsWith(".rtf")) {
      setToastConfig({
        isVisible: true,
        message: "Only RTF (.rtf) files are supported",
        type: "error",
      });

      setTimeout(() => {
        setToastConfig((prev) => ({
          ...prev,
          isVisible: false,
        }));
      }, 2000);
      e.target.value = "";
      return;
    }

    const reader = new FileReader();

    reader.onload = function (event) {
      try {
        const base64String = event.target.result.split(",")[1];

        if (!base64String) {
          throw new Error("Invalid file data");
        }

        setdocumentAsBase64(base64String);
        setEditToggle(true);
        setAdd(true);
        setEditorReloadKey((prev) => prev + 1);
      } catch (err) {
        console.error("Error processing file:", err);
        alert("Failed to load RTF file.");
      }
    };

    reader.onerror = function () {
      alert("Error reading file.");
    };

    reader.readAsDataURL(file);
    e.target.value = "";
  };

  return (
    <>
      <Popup
        visible={isFindPopupVisible}
        onHiding={() => setIsFindPopupVisible(false)}
        showTitle={false}
        width={1059}
        // width="auto"
        height={850}
        showCloseButton={true}
        hideOnOutsideClick={false}
      >
        <ReportCatalogFindPopup
          setIsFindPopupVisible={setIsFindPopupVisible}
          setRowData={setRowData}
          setFields={setFields}
          fields={fields}
          rowData={rowData}
          documentAsBase64={documentAsBase64}
          onRefresh={getReportsRef}
          setAdd={setAdd}
          setEditToggle={setEditToggle}
        />
      </Popup>
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: "none" }}
        accept=".rtf"
        onChange={(e) => handleFileImport(e)}
      />
      <LoadPanel shadingColor="true" visible={loading} delay={10} />
      <Toster message={toastConfig.message} type={toastConfig.type} visible={toastConfig.isVisible} />
      <div className="page-section">
        <DynamicTabb />
        <div className="page-content">
          <div style={{ display: "flex" }}>
            <p className="page-info-number">RC.1</p>
          </div>
          <div className="page-info-buttons">
            <div className="buttons">
              <button
                className="btn"
                onClick={() => {
                  setOriginalData({
                    fields: JSON.parse(JSON.stringify(fields)),
                    documentAsBase64,
                    htmlData,
                    rowData,
                  });
                  setAdd(true);
                  setEditToggle(true);
                  setClone(false);
                  resetFields();
                  setRowData({});
                  setdocumentAsBase64(defaultBase64);
                  setEditorReloadKey((prev) => prev + 1);
                }}
              >
                New
                <svg
                  className="svg-blue-white"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <g clip-path="url(#clip0_6247_15083)">
                    <path
                      d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM16 13H13V16C13 16.55 12.55 17 12 17C11.45 17 11 16.55 11 16V13H8C7.45 13 7 12.55 7 12C7 11.45 7.45 11 8 11H11V8C11 7.45 11.45 7 12 7C12.55 7 13 7.45 13 8V11H16C16.55 11 17 11.45 17 12C17 12.55 16.55 13 16 13Z"
                      fill="#424167"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_6247_15083">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </button>
              <button
                className="btn"
                disabled={disableCopy}
                onClick={() => {
                  if (disableCopy) return;
                  setAdd(true);
                  setClone(true);
                  setEditToggle(true);
                  resetFields();
                }}
              >
                Copy
                <svg
                  className="svg-blue-white"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <g clipPath="url(#clip0_copy_icon)">
                    <path
                      d="M16 1H4C2.9 1 2 1.9 2 3V15H4V3H16V1ZM19 5H8C6.9 5 6 5.9 6 7V21C6 22.1 6.9 23 8 23H19C20.1 23 21 22.1 21 21V7C21 5.9 20.1 5 19 5ZM19 21H8V7H19V21Z"
                      fill="#424167"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_copy_icon">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </button>
              <button
                className="btn"
                disabled={disableEdit}
                onClick={() => {
                  //   setEditStatus(!editStatus);
                  //   setisEditable(!isEditable);
                  //   setErrors({});
                  if (disableEdit) return;
                  setOriginalData({
                    fields: JSON.parse(JSON.stringify(fields)),
                    documentAsBase64,
                    htmlData,
                    rowData,
                  });
                  setEditToggle(true);
                }}
              >
                Edit
                <svg
                  className="svg-blue-white"
                  width="18"
                  height="19"
                  viewBox="0 0 18 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0 15.4601V18.5001C0 18.7801 0.22 19.0001 0.5 19.0001H3.54C3.67 19.0001 3.8 18.9501 3.89 18.8501L14.81 7.94006L11.06 4.19006L0.15 15.1001C0.0500001 15.2001 0 15.3201 0 15.4601ZM17.71 5.04006C18.1 4.65006 18.1 4.02006 17.71 3.63006L15.37 1.29006C14.98 0.900059 14.35 0.900059 13.96 1.290F06L12.13 3.12006L15.88 6.87006L17.71 5.04006Z"
                    fill="white"
                  />
                </svg>
              </button>
              <button
                className="btn"
                // onClick={() => {
                //     setprewviewtogal(!prewviewtogal);
                //     if (rowData?.sName && prewviewtogal !== undefined) {
                //         printTableData();
                //     }
                // }}
                onClick={PrintDocument}
              >
                Print
                <svg
                  className="svg-blue-white"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <g clipPath="url(#clip0_5985_7014)">
                    <path
                      d="M19 8H5C3.34 8 2 9.34 2 11V15C2 16.1 2.9 17 4 17H6V19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V17H20C21.1 17 22 16.1 22 15V11C22 9.34 20.66 8 19 8ZM15 19H9C8.45 19 8 18.55 8 18V14H16V18C16 18.55 15.55 19 15 19ZM19 12C18.45 12 18 11.55 18 11C18 10.45 18.45 10 19 10C19.55 10 20 10.45 20 11C20 11.55 19.55 12 19 12ZM17 3H7C6.45 3 6 3.45 6 4V6C6 6.55 6.45 7 7 7H17C17.55 7 18 6.55 18 6V4C18 3.45 17.55 3 17 3Z"
                      fill="#424167"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_5985_7014">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </button>
              {/* <button
                                className="btn"
                            // onClick={() => {
                            //   if (params?.id) {
                            //     setTypeFeeSchedule("Edit");
                            //     apiClass.ContectTypeDropDown(setcontactInfoType);
                            //     apiClass.getContactsEntityListDropdown(
                            //       SetContactsEntityListDropdown,
                            //       setReportCatalogData
                            //     );
                            //     getContactHeaderInfoDetails(params?.id);

                            //   }
                            // }}
                            >
                                Refresh
                                <svg
                                    className="svg-blue-white"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                >
                                    <g clip-path="url(#clip0_6247_15093)">
                                        <path
                                            d="M17.6493 6.34902C16.0193 4.71902 13.7093 3.77902 11.1693 4.03902C7.49929 4.40902 4.47929 7.38902 4.06929 11.059C3.51929 15.909 7.26929 19.999 11.9993 19.999C15.1893 19.999 17.9293 18.129 19.2093 15.439C19.5293 14.769 19.0493 13.999 18.3093 13.999C17.9393 13.999 17.5893 14.199 17.4293 14.529C16.2993 16.959 13.5893 18.499 10.6293 17.839C8.40929 17.349 6.61929 15.539 6.14929 13.319C5.30929 9.43902 8.25929 5.99902 11.9993 5.99902C13.6593 5.99902 15.1393 6.68902 16.2193 7.77902L14.7093 9.28902C14.0793 9.91902 14.5193 10.999 15.4093 10.999H18.9993C19.5493 10.999 19.9993 10.549 19.9993 9.99902V6.40902C19.9993 5.51902 18.9193 5.06902 18.2893 5.69902L17.6493 6.34902Z"
                                            fill="#424167"
                                        />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_6247_15093">
                                            <rect width="24" height="24" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </button> */}
              <button
                className="btn"
                onClick={() => {
                  setIsFindPopupVisible(true);
                }}
              >
                Find
                <svg
                  className="svg-blue-white"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <g clip-path="url(#clip0_6247_15088)">
                    <path
                      d="M15.5006 14.0006H14.7106L14.4306 13.7306C15.6306 12.3306 16.2506 10.4206 15.9106 8.39063C15.4406 5.61063 13.1206 3.39063 10.3206 3.05063C6.09063 2.53063 2.53063 6.09063 3.05063 10.3206C3.39063 13.1206 5.61063 15.4406 8.39063 15.9106C10.4206 16.2506 12.3306 15.6306 13.7306 14.4306L14.0006 14.7106V15.5006L18.2506 19.7506C18.6606 20.1606 19.3306 20.1606 19.7406 19.7506C20.1506 19.3406 20.1506 18.6706 19.7406 18.2606L15.5006 14.0006ZM9.50063 14.0006C7.01063 14.0006 5.00063 11.9906 5.00063 9.50063C5.00063 7.01063 7.01063 5.00063 9.50063 5.00063C11.9906 5.00063 14.0006 7.01063 14.0006 9.50063C14.0006 11.9906 11.9906 14.0006 9.50063 14.0006Z"
                      fill="#424167"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_6247_15088">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </button>
              <button
                className="btn"
                disabled={!isEditable}
                onClick={() => {
                  if (!isEditable) return;
                  SaveData();
                }}
              >
                Save
                <svg
                  className="svg-blue-white"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <g clipPath="url(#clip0_save_icon)">
                    <path
                      d="M17 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V7L17 3ZM12 19C10.34 19 9 17.66 9 16C9 14.34 10.34 13 12 13C13.66 13 15 14.34 15 16C15 17.66 13.66 19 12 19ZM15 9H5V5H15V9Z"
                      fill="#424167"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_save_icon">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </button>
              <button
                className="btn"
                // disabled={!isEditable}
                onClick={() => {
                  // if (!isEditable) return;
                  fileInputRef.current.click();
                }}
              >
                Import
                <svg
                  className="svg-blue-white"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <g clipPath="url(#clip0_import_icon)">
                    <path
                      d="M5 20H19C20.1 20 21 19.1 21 18V16H19V18H5V16H3V18C3 19.1 3.9 20 5 20ZM12 2L6.5 7.5L7.91 8.91L11 5.83V15H13V5.83L16.09 8.91L17.5 7.5L12 2Z"
                      fill="#424167"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_import_icon">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </button>
              <button className="btn" disabled={!isEditable} onClick={handleCancel}>
                Cancel
                <svg
                  className="svg-blue-white"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <g clipPath="url(#clip0_cancel_icon)">
                    <path
                      d="M18.3 5.71C17.91 5.32 17.28 5.32 16.89 5.71L12 10.59L7.11 5.7C6.72 5.31 6.09 5.31 5.7 5.7C5.31 6.09 5.31 6.72 5.7 7.11L10.59 12L5.7 16.89C5.31 17.28 5.31 17.91 5.7 18.3C6.09 18.69 6.72 18.69 7.11 18.3L12 13.41L16.89 18.3C17.28 18.69 17.91 18.69 18.3 18.3C18.69 17.91 18.69 17.28 18.3 16.89L13.41 12L18.3 7.11C18.68 6.73 18.68 6.09 18.3 5.71Z"
                      fill="#424167"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_cancel_icon">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </button>
            </div>
          </div>
          <div className="page-details-search-content">
            <div className="display-flex-div dropdown-space">
              <label className="edit_container_label">Report Name</label>
              {add ? (
                <TextBox
                  disabled={add ? false : true}
                  onValueChange={(e) => {
                    setFields({
                      ...fields,
                      reportname: {
                        name: e,
                        id: "00000000-0000-0000-0000-000000000000",
                      },
                    });
                  }}
                ></TextBox>
              ) : (
                <TextBox
                  disabled={editToggle ? false : true}
                  value={fields?.reportname?.name}
                  onValueChange={(e) => {
                    setFields({
                      ...fields,
                      reportname: {
                        name: e,
                        id: fields?.reportname?.id,
                      },
                    });
                  }}
                />
              )}
            </div>
            <div className="display-flex-div dropdown-space">
              <label className="edit_container_label">Report Type</label>
              <DropDown
                // disabled={add ? false : true}
                disabled={!(add || editToggle)}
                setfields={setFields}
                fields={fields}
                fieldNmae={"reporttype"}
                dropDownData={masterDropdownValues?.reportType?.map((vall) => {
                  return {
                    name: vall?.value,
                    id: vall?.key,
                  };
                })}
              />
            </div>
            <div className="display-flex-div dropdown-space">
              <label className="edit_container_label">Parent Form</label>
              <DropDown
                // disabled={add ? false : true}
                disabled={!(add || editToggle)}
                setfields={setFields}
                fields={fields}
                fieldNmae={"parentform"}
                dropDownData={masterDropdownValues?.parentForm?.map((vall) => {
                  return {
                    name: vall?.value,
                    id: vall?.key,
                  };
                })}
              />
            </div>
          </div>
          <div className="report-catalog-output">
            {/* <ReportCatalogOutput
                            documentWizardOutputData={rowData}
                            htmlData={add ? (clone ? rowData.sReportHtml : " ") : rowData.sReportHtml}
                            setHtmlData={setHtmlData}
                            add={add}
                            editToggle={editToggle}
                            reportname={fields.reportname.name}
                        /> */}
            {/* <RichEditComponent htmlContent={rowData}/> */}
            <div className="document-wizard-output-tab">
              <p className={fields.reportname.name ? "html-data-tab-name" : ""}>
                {fields.reportname.name ? fields.reportname.name : ""}
              </p>
            </div>
            {(add || documentAsBase64) && (
              <RichEditComponent
                key={editorReloadKey}
                documentAsBase64={documentAsBase64}
                editToggle={isEditable}
                reportname={fields.reportname.name}
                setdocumentAsBase64={setdocumentAsBase64}
                SaveData={SaveData}
                clone={clone}
                updatedocumentAsBase64={updatedocumentAsBase64}
              />
            )}
            {/* {rowData.sReportHtml && <RichEditComponent documentAsBase64={rtfbase64} editToggle={editToggle} reportname={fields.reportname.name} setdocumentAsBase64={setdocumentAsBase64} SaveData={SaveData} clone={clone} updatedocumentAsBase64={updatedocumentAsBase64} />} */}
          </div>
        </div>
      </div>
    </>
  );
};
export default ReportCatalog;
